import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { HasPermission } from '@iris-platform/protektor';
import { stylesToPropType } from '../../../utils';
import applicationPropType from '../applicationPropType';
import PingID from './PingID';
import Sso from './Sso';
import TokenExchange from './TokenExchange';
import { PROTEKTOR_VIEW } from '../../../utils/protektorConstants';

const styles = () => ({
  root: {},
});

const AuthTab = ({ application, classes, role }) => (
  <Fragment>
    <HasPermission to={PROTEKTOR_VIEW} access="Application_Auth_Tab_PingID" forRole={role}>
      <PingID appKey={application.clientID} />
    </HasPermission>
    <br />
    <HasPermission to={PROTEKTOR_VIEW} access="Application_Auth_Tab_SSO" forRole={role}>
      <Sso appKey={application.clientID} />
    </HasPermission>
    <br />
    <HasPermission to={PROTEKTOR_VIEW} access="Application_Auth_Tab_Token_Exchange" forRole={role}>
      <TokenExchange appKey={application.clientID} />
    </HasPermission>
  </Fragment>
);

AuthTab.propTypes = {
  application: applicationPropType.isRequired,
  classes: stylesToPropType(styles()).isRequired,
  role: PropTypes.object.isRequired,
};

export default withStyles(styles)(AuthTab);
